<template>
  <splide-slide :class="['carousel-slide-fi', theme ? `carousel-slide-fi--theme-${theme}` : '']">
    <slot />
  </splide-slide>
</template>

<script setup lang="ts">
// @ts-expect-error
import { SplideSlide } from '@splidejs/vue-splide';

defineOptions({
  name: 'CarouselSlideFi',
});

defineProps<{
  theme?: string;
}>();
</script>

<style scoped src="./carousel-slide-fi" />
